module.exports = __webpack_public_path__ + "static/media/error.579e2f7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/error.mp3
// module id = xONB
// module chunks = 313